// Styles
import "../scss/main.scss";

// Import asset images
import "./images";

// Import javascript
// import debounce from './helpers/debounce';

// import SmoothScroll from './vendor/smoothScroll';

// import cssVars from 'css-vars-ponyfill';

// import { randomNumberBetween, sleep, memoize } from "./utilities/other";

// import menu from './components/menu';
// import swiper from './components/swiper';
import newsFiltering from "./components/newsFiltering";
import toggleModal from "./components/teamModal";
import toggleMenu from "./layouts/nav";
import animations from "./animations";
import sliders from './sliders';

document.addEventListener("DOMContentLoaded", function () {
  // let smoothScroll = new SmoothScroll('a[href*="#"][data-smooth]', { header: '#header', offset: 20 });

  // cssVars({});
  // menu();
  // swiper();
  toggleMenu();
  newsFiltering();
  toggleModal();
  animations();
  sliders();

  window.addEventListener("resize", function () {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  });
});
